import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import api, { formatApiErrorDetail } from '../../lib/api';
import { toast } from 'sonner';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="min-h-screen pt-32 flex items-center justify-center bg-[#f1e3eb]">
      <div className="w-full max-w-md px-4 py-12">
        <Card className="border-0 shadow-xl">
          <CardHeader className="text-center pb-2">
            <CardTitle className="font-serif text-2xl text-[#3c4a2a]">Forgot Password</CardTitle>
            <CardDescription className="text-[#3c4a2a]/60">
              Enter your email and we'll send you a reset link
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-6">
            {sent ? (
              <div className="text-center" data-testid="forgot-password-sent-message">
                <p className="text-[#5f6d51] mb-6">
                  If an account exists with this email, a reset link has been sent.
                </p>
                <Link to="/login">
                  <Button variant="outline" className="border-[#5d6b3c] text-[#5d6b3c]">
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Back to Login
                  </Button>
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <Label htmlFor="email" className="text-[#3c4a2a]">Email Address</Label>
                  <div className="relative mt-2">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#3c4a2a]/40" />
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      data-testid="forgot-password-email-input"
                      className="pl-10 border-[#bd8cae]/50 focus:border-[#5d6b3c]"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>
                <Button
                  type="submit"
                  disabled={isLoading}
                  data-testid="forgot-password-submit-btn"
                  className="w-full bg-[#5d6b3c] hover:bg-[#3c4a2a] text-white py-6"
                >
                  {isLoading ? 'Sending...' : 'Send Reset Link'}
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
                <p className="text-center text-sm text-[#3c4a2a]/60">
                  <Link to="/login" className="text-[#5d6b3c] hover:text-[#3c4a2a]">Back to login</Link>
                </p>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </main>
  );
};

export default ForgotPasswordPage;
